import * as yup from 'yup';

type TFunction = (key: string, options?: Record<string, unknown>) => string;

export const initialAddressDto = {
  street: undefined,
  additionalStreet: undefined,
  cityId: undefined,
  cityName: undefined,
  countryName: undefined,
};

export const addressDtoSchema = (translate: TFunction) => {
  return yup.object().shape({
    street: yup
      .string()
      .required(translate('REQUIRED'))
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      })
      .max(38, translate(translate('MAX_CHAR').replace('{var}', '38'))),
    additionalStreet: yup
      .string()
      .max(38, translate(translate('MAX_CHAR').replace('{var}', '38'))),
    cityId: yup.string(),
    cityName: yup
      .string()
      .min(2, translate('CITY_NAME_MIN'))
      .required(translate('REQUIRED'))
      .test('no-empty-spaces', translate('REQUIRED'), (value) => {
        // Use a custom test to check if the value contains only spaces
        return value.trim() !== '';
      }),
    countryName: yup.string().required(translate('REQUIRED')),
    countryId: yup.string().required(translate('REQUIRED')),
  });
};
